// extracted by mini-css-extract-plugin
module.exports = {"title":"Advice_title__n8VFY","advice":"Advice_advice__MfrKO"};